import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import uuid from 'uuid'
import { Span } from 'components/layout'
// import { ConfigKey } from 'containers/forms/configuration'
import { ConfigurationText } from 'containers/misc'
import { ConfigurationKeySetModal } from 'components/modals'
import { CONFIGURATION_KEYS } from 'constants/enums'

export default class PaymentPrices extends Component {
  static propTypes = {
    configuration: PropTypes.object,
    activeOrganization: PropTypes.object,
    // isSameLevel: PropTypes.bool,
    parentOaId: PropTypes.number,
    modal: PropTypes.func,
    onUpdateConfigKey: PropTypes.func,
    onResetConfigKey: PropTypes.func,
    reset: PropTypes.func,
    change: PropTypes.func,
    initialize: PropTypes.func,
    isConfigUpdating: PropTypes.bool,
    handleSubmit: PropTypes.func
  }

  state = {
    config: {}
  }

  key = uuid.v1()

  handleChangeConfig = config => {
    this.setState(
      {
        config
      },
      () => {
        this.props.modal(`modal-configuration-key-${this.key}`)
      }
    )
  }

  handleRenderRow = ({
    level,
    levelIntlKey,
    oaConfigKey = {},
    naoConfigKey = {},
    orgCurrency
  }) => {
    const { activeOrganization, parentOaId } = this.props
    const currency = get(orgCurrency, 'codeListValue.value')

    return (
      <div className="row">
        <div className="col-xs-3">
          <Span intlKey={levelIntlKey} alignWithInput>
            {level}
          </Span>
        </div>
        {parentOaId && (
          <div className="col-xs-3">
            <ConfigurationText
              organizationId={activeOrganization.id}
              configKey={oaConfigKey}
              currency={currency}
            />
          </div>
        )}
        <div className="col-xs-3">
          <ConfigurationText
            organizationId={activeOrganization.id}
            configKey={naoConfigKey}
            currency={currency}
          />
        </div>
        <div className="col-xs-3">
          {this.handleCalculateTotal(
            parentOaId ? oaConfigKey.decimalValue : 0,
            naoConfigKey.decimalValue
          )}{' '}
          {currency}
        </div>
      </div>
    )
  }

  handleCalculateTotal = (oaFee = 0, naoFee = 0) => (
    <Span alignWithInput>{oaFee + naoFee}</Span>
  )

  render() {
    const { handleSubmit, configuration, parentOaId } = this.props

    return (
      <div>
        <div className="row">
          <div className="col-xs-3">
            <Span strong intlKey="label.level">
              Level
            </Span>
          </div>
          {parentOaId && (
            <div className="col-xs-3">
              <Span strong intlKey="label.oa_price">
                OA price
              </Span>
            </div>
          )}
          <div className="col-xs-3">
            <Span strong intlKey="label.nao_price">
              NAO price
            </Span>
          </div>
          <div className="col-xs-3">
            <Span strong intlKey="label.total">
              Total
            </Span>
          </div>
        </div>

        <hr className="hr" />

        <div className="row">
          <div className="col-xs-12">
            <Span uppercase intlKey="label.direct_entrant">
              Direct entrant
            </Span>
            <hr className="hr" />
          </div>
        </div>

        {this.handleRenderRow({
          level: 'Bronze level',
          levelIntlKey: 'award.bronze_level',
          oaConfigKey:
            configuration.values[CONFIGURATION_KEYS.directOaBronze.id],
          naoConfigKey:
            configuration.values[CONFIGURATION_KEYS.directNaoBronze.id],
          orgCurrency: configuration.values[CONFIGURATION_KEYS.orgCurrency.id]
        })}

        {this.handleRenderRow({
          level: 'Silver level',
          levelIntlKey: 'award.silver_level',
          oaConfigKey:
            configuration.values[CONFIGURATION_KEYS.directOaSilver.id],
          naoConfigKey:
            configuration.values[CONFIGURATION_KEYS.directNaoSilver.id],
          orgCurrency: configuration.values[CONFIGURATION_KEYS.orgCurrency.id]
        })}

        {this.handleRenderRow({
          level: 'Gold level',
          levelIntlKey: 'award.gold_level',
          oaConfigKey: configuration.values[CONFIGURATION_KEYS.directOaGold.id],
          naoConfigKey:
            configuration.values[CONFIGURATION_KEYS.directNaoGold.id],
          orgCurrency: configuration.values[CONFIGURATION_KEYS.orgCurrency.id]
        })}

        <hr className="hr" />

        <div className="row">
          <div className="col-xs-12">
            <Span uppercase intlKey="label.continuation_level">
              Continuation level
            </Span>
            <hr className="hr" />
          </div>
        </div>

        {this.handleRenderRow({
          level: 'Bronze level',
          levelIntlKey: 'award.bronze_level',
          oaConfigKey:
            configuration.values[CONFIGURATION_KEYS.continuationOaBronze.id],
          naoConfigKey:
            configuration.values[CONFIGURATION_KEYS.continuationNaoBronze.id],
          orgCurrency: configuration.values[CONFIGURATION_KEYS.orgCurrency.id]
        })}

        {this.handleRenderRow({
          level: 'Silver level',
          levelIntlKey: 'award.silver_level',
          oaConfigKey:
            configuration.values[CONFIGURATION_KEYS.continuationOaSilver.id],
          naoConfigKey:
            configuration.values[CONFIGURATION_KEYS.continuationNaoSilver.id],
          orgCurrency: configuration.values[CONFIGURATION_KEYS.orgCurrency.id]
        })}

        {this.handleRenderRow({
          level: 'Gold level',
          levelIntlKey: 'award.gold_level',
          oaConfigKey:
            configuration.values[CONFIGURATION_KEYS.continuationOaGold.id],
          naoConfigKey:
            configuration.values[CONFIGURATION_KEYS.continuationNaoGold.id],
          orgCurrency: configuration.values[CONFIGURATION_KEYS.orgCurrency.id]
        })}

        {this.handleRenderRow({
          level: 'Bronze To Gold level',
          levelIntlKey: 'award.bronze_to_gold_level',
          oaConfigKey:
            configuration.values[CONFIGURATION_KEYS.continuationOaBronzeToGold.id],
          naoConfigKey:
            configuration.values[CONFIGURATION_KEYS.continuationNaoBronzeToGold.id],
          orgCurrency: configuration.values[CONFIGURATION_KEYS.orgCurrency.id]
        })}

        <div className="base-margin" />

        <ConfigurationKeySetModal
          modalId={`modal-configuration-key-${this.key}`}
          data={this.state.config}
          handleSubmit={handleSubmit}
          onUpdateConfigKey={this.props.onUpdateConfigKey}
          onResetConfigKey={this.props.onResetConfigKey}
          modal={this.props.modal}
          reset={this.props.reset}
          change={this.props.change}
          initialize={this.props.initialize}
          isConfigUpdating={this.props.isConfigUpdating}
        />
      </div>
    )
  }
}
